import * as React from 'react';
const SvgTriangleFillRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.127 9.244a1 1 0 0 1 0 1.512l-3.472 3.007A1 1 0 0 1 8 13.007V6.993a1 1 0 0 1 1.655-.756z"
    />
  </svg>
);
export default SvgTriangleFillRight;
